export default "__VITE_ASSET__BcwqWtFs__"